import { Outlet } from 'react-router-dom';

function OrdenPago() {
  return <Outlet />;
}

export default OrdenPago;
